import { h, Component } from "preact";
import { WelcomeComponent } from "./welcome/welcome";
import Api from "./api";

import Header from "./user/header";
import { LibraryComponent } from "./user/library/library";
import Navigation, { Pages } from "./navigation";
import ReaderComponent from "./user/reader/reader";
import { StatsComponent } from "./user/stats/stats";
import { AddComponent } from "./user/add/add";
import { DetailsComponent } from "./user/details/details";
import BrowsePage from "./user/browse";
import { ModalController, showModal } from "./modal";
import { useState, useEffect } from "preact/hooks";
import EditorPage from "./user/add/editor";

export interface AppProps {
   name: string;
}

interface IAppPage {
   page: Pages;
   state: any;
}

export default function App() {
   const [loggedIn, setLoggedIn] = useState(!Api.needLogin);
   const [page, setPage] = useState<IAppPage>({
      page: Navigation.page,
      state: Navigation.state,
   });

   useEffect(() => {
      const onLogin = ({ need_login }) => {
         setLoggedIn(!need_login);
      };

      const onPage = (page: IAppPage) => {
         setPage(page);
      };

      Api.loginObservable.subscribe(onLogin);
      Navigation.pageObservable.subscribe(onPage);
      return () => {
         Api.loginObservable.unsubscribe(onLogin);
         Navigation.pageObservable.unsubscribe(onPage);
      };
   }, []);

   if (!loggedIn) return <WelcomeComponent />;

   let component: h.JSX.Element;

   switch (page.page) {
      case Pages.Library:
         component = <LibraryComponent key="Library" />;
         break;
      case Pages.Reader:
         component = <ReaderComponent id={page.state} key="Reader" />;
         break;
      case Pages.Stats:
         component = <StatsComponent key="Stats" />;
         break;
      case Pages.Add:
         component = <AddComponent key="Add" />;
         break;
      case Pages.Details:
         component = <DetailsComponent id={page.state} key="Details" />;
         break;
      case Pages.Browse:
         component = <BrowsePage key="Browse" />;
         break;
      case Pages.Edit:
         component = <EditorPage key="EditorPage" />;
         break;
   }

   return (
      <div>
         <ModalController />
         <div>
            <Header />
            {component}
         </div>
      </div>
   );
}

(window as any).showModal = () => {
   showModal(() => <h1>Hallo Welt</h1>);
};
